import React from 'react';
import TshirtPic from '../Assets/tshirt.jpg';
import './ClothingHeading.css';

import print1 from './media/print1.PNG';
import print2 from './media/print2.PNG';
import print3 from './media/print3.PNG';
const PrintHeading = () => {
    const goTo = () => {
        window.location.href = '/prints';
    };

    const width = window.innerWidth;

    return (
        <div className='imageTextContainer' onClick={goTo} style={{ cursor: 'pointer' }}>
            <div className='imageContainer'>
                <img src={print2} alt="Sample" className='responsiveImage' />
                <img src={print3} alt="Sample" className='responsiveImage' />
                {width > 800 && <img src={print1} alt="Sample" className='responsiveImage' />}
            </div>
            <div className='textContainer'>
                <p>Shop Prints Here</p>
            </div>
        </div>
    );
};
export default PrintHeading;